<template>
  <!-- 外部媒体看本地 -->
  <div class="wlmq_cityHot_container">
    <div class="head">
      <div class="head_title">
        媒体看消防
      </div>
    </div>
    <div class="main">
      <div class="leftMain">
        <div class="mainTitle">时间脉络</div>
        <div class="leftContent" id="demo">
          <div class="line"></div>
          <ul id="demo1">
            <li
                class="diamonds"
                v-for="(item, index) in newdataList"
                :key="index"
                :class="activeIndex == index ? 'active1' : ''"
                @click="getContent(item, index)"
            >
              <div class="diamondsTitle">{{item.TITLE}}</div>
              <div class="pic">
                <img v-if="item.HEAD_IMG!=null" class="pic_img" :src="item.HEAD_IMG" alt />
                <img v-else class="pic_img" src="../../assets/Starting/img-information/logo.png" alt />
                <div class="time">
                  <div>{{ item.SOURCE_NAME }}</div>
                  <div>{{ item.NEWS_TIME}}</div>
                </div>
              </div>
            </li>
          </ul>
          <span class="icons">
            <i
                class="iconfont icon-sancenghuan"
                v-for="(item, index) in newdataList"
                :key="index"
                :class="activeIndex == index ? 'active2' : ''"
            ></i>
          </span>
          <span class="dashed" v-for="(item, index) in newdataList" :key="index"></span>
        </div>
      </div>
      <div class="rightMain">
        <div class="mainTitle">新闻详情</div>

        <div class="rightContent" v-if="showBody.TITLE">
          <div class="newTitle">{{ showBody.TITLE }}</div>
          <div class="newSource">
            <span>{{ showBody.SOURCE_NAME }}</span>
            <span>{{ showBody.NEWS_TIME }}</span>
          </div>
          <div class="newContent">
            {{ showBody.CONTENT }}
            <div class="time_img" v-if="showBody.THUMBNAIL_LOCAL!='undefined'">
              <div class="wx_img" v-for="(item,index) in showBody.THUMBNAIL_LOCAL" :key="index">
                <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imageurl" alt />
              </div>
            </div>
            <div v-if="showBody.MP4_URL!=null" class="video_time">
              <video v-if="showBody.MP4_URL!=null" :src="showBody.MP4_URL" controls="controls"></video>
            </div>
          </div>

          <div class="time_img" v-if="showBody.picturesList!='undefined'">
            <div class="wx_img" v-for="(item,index) in  showBody.picturesList" :key="index">
              <img v-if="item.imgUrl!=''" class="img_wx" :src="item.imageurl" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getFireControl} from "@/api/bot";

export default {
  data() {
    return {
      title: "媒体看消防",
      list_data: [],
      diamonds1: [],
      diamonds2: [],
      //详情页
      showBody: "",
      show: false,
      detailInfo: "",
      activeIndex: "0",
      interval: "",
      wxPicturesList: [],
      picturesList: []
    };
  },
  created() {
    this.load();
  },
  mounted() {},
  destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    imgUrl() {
      return request.defaults.baseURL;
    }
  },
  computed: {
    newdataList: function() {
      return this.sortKey(this.list_data, "NEWS_TIME");
    }
  },
  methods: {
    sortKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key];
        var y = b[key];
        return x > y ? -1 : x < y ? 1 : 0;
      });
    },
    load() {
      getFireControl().then(res => {
        this.diamonds1 = res.data.data[0];
        this.diamonds2 = res.data.data[1];
        if (this.diamonds2 == undefined) {
          this.list_data = this.diamonds1;
        } else {
          this.list_data = this.diamonds2.concat(this.diamonds1);
          console.log(this.list_data, "数据对象");
        }
        this.showBody = this.list_data[0];
        const self = this;
        if (this.list_data.length <= 6) {
          var time = 100000000;
        } else {
          var time = 5000;
        }
        this.interval = setInterval(() => {
          if (self.list_data != []) {
            if (self.activeIndex < 20) {
              self.activeIndex++;
              self.showBody = self.list_data[self.activeIndex];
              var demo = document.getElementById("demo");
              var demo1 = document.getElementById("demo1");

              if (demo.scrollTop <= demo1.offsetHeight) {
                demo.scrollTop = demo.scrollTop + 80;
              } else {
                demo.scrollTop = 0;
              }
            } else {
              self.activeIndex = 0;
              self.showBody = self.list_data[0];
              var demo = document.getElementById("demo");
              var demo1 = document.getElementById("demo1");
              demo.scrollTop = 0;
            }
          }
        }, time);
      });
    },
    getContent(item, index) {
      this.activeIndex = index;
      this.showBody = item;
    }
  }
};
</script>

<style scoped lang="scss">
.video_time {
  width: 100%;
  height: 200px;
  margin-top: 20px;
}
.video {
  width: 70%;
  height: 200px;
}

.time_img {
  width: 100%;
  height: 400px;
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  // overflow-y: scroll;
}
.wx_img {
  padding: 10px;
  .img_wx {
    width: 170px;
    height: 140px;
  }
}
.wlmq_cityHot_container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/Starting/img-information/expert_bg_img.jpg");
  background-size: 100% 100%;
  .head {
    width: 100%;
    height: 12.5vh;
    display: flex;
    color: #fff;
    .head_title {
      font-weight: bold;
      font-size: 2vw;
      line-height: 12vh;
      width: 19%;
      margin-left: 2.3%;
      overflow: hidden;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      img {
        vertical-align: middle;
        width: 13%;
        height: 5.2vh;
        margin-right: 3.2%;
      }
    }
    .head_logo {
      width: 8.67%;
      height: 4.44vh;
      position: absolute;
      top: 4vh;
      right: 4%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .main {
    width: calc(100% - 6%);
    height: calc(100% - 9.5vh - 6.4vh - 17px);
    margin: -0.8vh 3% 3.2vh 3%;
    display: flex;
    justify-content: space-around;
    .leftMain,
    .rightMain {
      background-image: url("../../assets/Starting/img-information/media.png");
      background-size: 100% 100%;
      width: 898px;
      height: 100%;
    }
    .mainTitle {
      width: 16%;
      height: 3.4vh;
      margin-left: 2.5%;
      font-size: 0.94vw;
      font-weight: bold;
      color: #1db6e9;
      line-height: 3.7vh;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    ::-webkit-scrollbar {
      width: 0; /*对垂直流动条有效*/
    }
    .active1 {
      background: linear-gradient(
              90deg,
              rgba(90, 41, 206, 1) 0%,
              rgba(153, 35, 218, 1) 100%
      ) !important;
    }
    .active2 {
      font-size: 1.4vw !important;
      left: 48.3% !important;
    }
    .active2:nth-child(1) {
      top: 6.8vh !important;
    }
    .active2:nth-child(2) {
      top: 17.8vh !important;
    }
    .active2:nth-child(3) {
      top: 28.8vh !important;
    }
    .active2:nth-child(4) {
      top: 39.8vh !important;
    }
    .active2:nth-child(5) {
      top: 50.8vh !important;
    }
    .active2:nth-child(6) {
      top: 61.8vh !important;
    }
    .active2:nth-child(7) {
      top: 72.8vh !important;
    }
    .active2:nth-child(8) {
      top: 83.8vh !important;
    }
    .active2:nth-child(9) {
      top: 94.8vh !important;
    }
    .active2:nth-child(10) {
      top: 105.8vh !important;
    }
    .active2:nth-child(11) {
      top: 116.8vh !important;
    }
    .active2:nth-child(12) {
      top: 127.8vh !important;
    }
    .active2:nth-child(13) {
      top: 138.8vh !important;
    }
    .active2:nth-child(14) {
      top: 149.8vh !important;
    }
    .active2:nth-child(15) {
      top: 160.8vh !important;
    }
    .active2:nth-child(16) {
      top: 171.8vh !important;
    }
    .active2:nth-child(17) {
      top: 182.8vh !important;
    }
    .active2:nth-child(18) {
      top: 193.8vh !important;
    }
    .active2:nth-child(19) {
      top: 204.8vh !important;
    }
    .active2:nth-child(20) {
      top: 215.8vh !important;
    }
    .leftContent {
      width: 87%;
      height: calc(100% - 3.4vh - 8vh);
      margin: 2.5vh 6.5%;
      position: relative;
      overflow-y: scroll;
      ul {
        height: 320%;
      }
      .line {
        height: 320%;
        width: 1px;
        background: rgba(11, 246, 255, 1);
        position: absolute;
        left: 50%;
      }
      .diamonds {
        width: 41%;
        height: 15vh;
        padding: 1vh 2%;
        background: linear-gradient(
                90deg,
                rgba(40, 157, 204, 1) 0%,
                rgba(129, 94, 255, 1) 100%
        );
        position: absolute;
        color: #fff;
        cursor: pointer;
        .diamondsTitle {
          width: 100%;
          height: 7.6vh;
          font-size: 1.25vw;
          font-weight: bold;
          color: white;
          line-height: 1.5;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .pic {
          display: flex;
          .pic_img {
            width: 35px;
            height: 35px;
            border-radius: 50%;
          }
          .t {
            width: 12.32%;
            height: 4.14vh;
            border-radius: 50%;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .time {
            margin-left: 4%;
            width: 83%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            div {
              font-size: 0.84vw;
            }
            div:nth-child(2) {
              opacity: 0.5;
            }
          }
        }
      }

      .diamonds:hover {
        background: linear-gradient(
                90deg,
                rgba(90, 41, 206, 1) 0%,
                rgba(153, 35, 218, 1) 100%
        );
      }
      .iconfont:hover {
        font-size: 1.4vw;
        left: 48.3%;
      }
      .iconfont:nth-child(1):hover {
        top: 10vh;
      }
      .iconfont:nth-child(2):hover {
        top: 20vh;
      }
      .iconfont:nth-child(3):hover {
        top: 31vh;
      }
      .iconfont:nth-child(4):hover {
        top: 40vh;
      }
      .iconfont:nth-child(5):hover {
        top: 46.8vh;
      }
      .iconfont:nth-child(7):hover {
        top: 56.8vh;
      }
      .iconfont:nth-child(8):hover {
        top: 66.8vh;
      }
      .iconfont:nth-child(9):hover {
        top: 76.8vh;
      }
      .iconfont:nth-child(10):hover {
        top: 86.8vh;
      }
      .iconfont:nth-child(11):hover {
        top: 96.8vh;
      }
      .iconfont:nth-child(12):hover {
        top: 106.8vh;
      }
      .iconfont:nth-child(13):hover {
        top: 116.8vh;
      }
      .iconfont:nth-child(14):hover {
        top: 126.8vh;
      }
      .iconfont:nth-child(15):hover {
        top: 136.8vh;
      }
      .iconfont:nth-child(16):hover {
        top: 146.8vh;
      }
      .iconfont:nth-child(17):hover {
        top: 156.8vh;
      }
      .iconfont:nth-child(18):hover {
        top: 166.8vh;
      }
      .iconfont:nth-child(19):hover {
        top: 176.8vh;
      }
      .iconfont:nth-child(20):hover {
        top: 186.8vh;
      }
      .iconfont {
        position: absolute;
        left: 48.55%;
        color: #0af6ff;
        font-size: 1.2vw;
        z-index: 99;
        background: #03132c;
      }
      .iconfont:nth-child(1) {
        top: 7vh;
      }
      .iconfont:nth-child(2) {
        top: 18vh;
      }
      .iconfont:nth-child(3) {
        top: 29vh;
      }
      .iconfont:nth-child(4) {
        top: 40vh;
      }
      .iconfont:nth-child(5) {
        top: 51vh;
      }
      .iconfont:nth-child(6) {
        top: 62vh;
      }
      .iconfont:nth-child(7) {
        top: 73vh;
      }
      .iconfont:nth-child(8) {
        top: 84vh;
      }
      .iconfont:nth-child(9) {
        top: 95vh;
      }
      .iconfont:nth-child(10) {
        top: 106vh;
      }
      .iconfont:nth-child(11) {
        top: 117vh;
      }
      .iconfont:nth-child(12) {
        top: 128vh;
      }
      .iconfont:nth-child(13) {
        top: 139vh;
      }
      .iconfont:nth-child(14) {
        top: 150vh;
      }
      .iconfont:nth-child(15) {
        top: 161vh;
      }
      .iconfont:nth-child(16) {
        top: 172vh;
      }
      .iconfont:nth-child(17) {
        top: 183vh;
      }
      .iconfont:nth-child(18) {
        top: 194vh;
      }
      .iconfont:nth-child(19) {
        top: 205vh;
      }
      .iconfont:nth-child(20) {
        top: 216vh;
      }
      .icons {
        z-index: 10;
      }
      .dashed {
        display: inline-block;
        height: 1px;
        width: 8%;
        border-top: 2px dashed rgba(11, 246, 255, 1);
        position: absolute;
        left: 50%;
        z-index: 1;
      }
      /*.dashed:nth-child(9){ left:47%; top: 7.9vh; }
				.dashed:nth-child(10){ left:44.9%; top: 18.8vh; }
				.dashed:nth-child(11){ left:47%; top: 29.9vh; }
				.dashed:nth-child(12){ left:44.9%; top: 40.9vh; }
				.dashed:nth-child(13){ left:47%; top: 51.9vh; }
				.dashed:nth-child(14){ left:44.9%; top: 61.9vh; }*/
      .dashed:nth-child(4) {
        left: 47%;
        top: 7.9vh;
      }
      .dashed:nth-child(5) {
        left: 44.9%;
        top: 18.8vh;
      }
      .dashed:nth-child(6) {
        left: 47%;
        top: 29.9vh;
      }
      .dashed:nth-child(7) {
        left: 44.9%;
        top: 40.9vh;
      }
      .dashed:nth-child(8) {
        left: 47%;
        top: 51.9vh;
      }
      .dashed:nth-child(9) {
        left: 44.9%;
        top: 62.9vh;
      }

      .dashed:nth-child(10) {
        left: 47%;
        top: 73.9vh;
      }
      .dashed:nth-child(11) {
        left: 44.9%;
        top: 84.9vh;
      }
      .dashed:nth-child(12) {
        left: 47%;
        top: 95.9vh;
      }
      .dashed:nth-child(13) {
        left: 44.9%;
        top: 106.9vh;
      }
      .dashed:nth-child(14) {
        left: 47%;
        top: 117.9vh;
      }
      .dashed:nth-child(15) {
        left: 44.9%;
        top: 128.9vh;
      }
      .dashed:nth-child(16) {
        left: 47%;
        top: 139.9vh;
      }
      .dashed:nth-child(17) {
        left: 44.9%;
        top: 150.9vh;
      }
      .dashed:nth-child(18) {
        left: 47%;
        top: 161.9vh;
      }
      .dashed:nth-child(19) {
        left: 44.9%;
        top: 172.9vh;
      }
      .dashed:nth-child(20) {
        left: 47%;
        top: 183.9vh;
      }
      .dashed:nth-child(21) {
        left: 44.9%;
        top: 194.9vh;
      }
      .dashed:nth-child(22) {
        left: 44.9%;
        top: 205.9vh;
      }
      .dashed:nth-child(23) {
        left: 44.9%;
        top: 216.9vh;
      }
      .diamonds:nth-child(1) {
        top: 0;
        right: 0;
      }
      .diamonds:nth-child(2) {
        top: 11vh;
        left: 0;
      }
      .diamonds:nth-child(3) {
        top: 22vh;
        right: 0;
      }
      .diamonds:nth-child(4) {
        top: 33vh;
        left: 0;
      }
      .diamonds:nth-child(5) {
        top: 44vh;
        right: 0;
      }
      .diamonds:nth-child(6) {
        top: 55vh;
        left: 0;
      }
      .diamonds:nth-child(7) {
        top: 66vh;
        right: 0;
      }
      .diamonds:nth-child(8) {
        top: 77vh;
        left: 0;
      }
      .diamonds:nth-child(9) {
        top: 88vh;
        right: 0;
      }
      .diamonds:nth-child(10) {
        top: 99vh;
        left: 0;
      }
      .diamonds:nth-child(11) {
        top: 110vh;
        right: 0;
      }
      .diamonds:nth-child(12) {
        top: 121vh;
        left: 0;
      }
      .diamonds:nth-child(13) {
        top: 132vh;
        right: 0;
      }
      .diamonds:nth-child(14) {
        top: 143vh;
        left: 0;
      }
      .diamonds:nth-child(15) {
        top: 154vh;
        right: 0;
      }
      .diamonds:nth-child(16) {
        top: 165vh;
        left: 0;
      }
      .diamonds:nth-child(17) {
        top: 176vh;
        right: 0;
      }
      .diamonds:nth-child(18) {
        top: 187vh;
        left: 0;
      }
      .diamonds:nth-child(19) {
        top: 196vh;
        right: 0;
      }
      .diamonds:nth-child(20) {
        top: 207vh;
        left: 0;
      }
    }
    .rightContent {
      width: 90%;
      height: calc(100% - 3.4vh - 4vh);
      margin: 2vh 5%;
      overflow: hidden;
      // overflow-y: auto;
      .newTitle {
        width: 100%;
        text-align: center;
        font-size: 1.9vw;
        font-weight: bold;
        color: white;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .newSource {
        width: 100%;
        height: 3vh;
        font-size: 0.95vw;
        color: #0bf6ff;
        line-height: 3vh;
        display: flex;
        margin-top: 3vh;
        justify-content: space-evenly;
      }
      .newContent {
        margin-top: 1vh;
        width: 100%;
        // height: calc(100% - 13vh);
        height: 55.5vh;
        font-size: 1.05vw;
        color: white;
        line-height: 1.5;
        // overflow: hidden;
        overflow-y: auto;
      }
      .newContent::-webkit-scrollbar {
        width: 5px;
        height: 3vh;
      }
      ::-webkit-scrollbar-thumb {
        /*定义滑块 内阴影+圆角*/
        height: 3vh;
        border-radius: 10px;
        // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: #1db6e9;
      }
    }
  }

  .dialogBody {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    z-index: 100;
    .deatilDialog {
      position: absolute;
      border: 1px solid #167fff;
      color: #fff;
      background-color: #002559;
      width: 59.5%;
      height: 85%;
      left: 21%;
      top: 6.5%;
      .detailHeader {
        text-align: right;
        padding: 16px 16px;
        color: #ffffff;
        .iconfont {
          cursor: pointer;
        }
      }

      .detailBody {
        height: calc(100% - 53px);
        overflow: hidden;
        overflow-y: auto;
        .detailTitle {
          padding: 0px 86px;
          font-size: 1.7vw;
          line-height: 1.4;
          display: block;
          overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
          font-weight: bold;
          text-align: center;
        }
        .detailOriginal {
          padding: 20px 35%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          color: #60d6dd;
          .original {
            display: flex;
            align-items: center;
            img {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
        .detailMain {
          padding: 0px 88px 0px 88px;
          margin-bottom: 72px;
          line-height: 2;
          font-size: 0.83vw;
        }
      }
    }
  }
  .closedialog {
    animation: action_scaleOut 0.2s ease forwards;
  }
  .opendialog {
    animation: action_translateY 0.3s ease;
  }
  @keyframes action_translateY {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  @keyframes action_scaleOut {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.2);
      opacity: 0;
    }
  }
}
</style>
